import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { CaseService } from './services/case.service';

export function provideOutlookCaseDataAccess(): EnvironmentProviders {
  return makeEnvironmentProviders([CaseService]);
}
